import React from "react";

/**
 * White outline version of the DGI mark, for use on the dark brand panel.
 * (The full-colour PNG in /assets is used on light backgrounds.)
 */
export default function DgiLogo({ width = 92 }) {
  return (
    <svg
      width={width}
      viewBox="0 0 120 142"
      fill="none"
      stroke="#ffffff"
      strokeWidth="4"
      strokeLinejoin="round"
      role="img"
      aria-label="DGI"
    >
      {/* pediment */}
      <path d="M60 6 14 34h92L60 6Z" />
      {/* architrave */}
      <rect x="10" y="34" width="100" height="10" rx="2" />
      {/* columns */}
      <rect x="24" y="50" width="18" height="38" rx="1.5" />
      <rect x="51" y="50" width="18" height="38" rx="1.5" />
      <rect x="78" y="50" width="18" height="38" rx="1.5" />
      <path d="M33 57v24M60 57v24M87 57v24" strokeWidth="2.5" />
      {/* stylobate */}
      <rect x="14" y="88" width="92" height="8" rx="2" />
      <rect x="8" y="96" width="104" height="10" rx="2" />
      {/* wordmark */}
      <text
        x="60"
        y="136"
        fill="#ffffff"
        stroke="none"
        textAnchor="middle"
        fontFamily="Georgia, 'Times New Roman', serif"
        fontSize="30"
        fontWeight="700"
        letterSpacing="8"
      >
        DGI
      </text>
    </svg>
  );
}
